<template>
  <component :is="isMobile ? MobileView : DesktopView" />
</template>

<script setup>
import { defineAsyncComponent } from 'vue'
import { isMobile } from '@/utils/device'

const props = defineProps({
  desktop: { type: Function, required: true },
  mobile: { type: Function, required: true }
})

const DesktopView = defineAsyncComponent(props.desktop)
const MobileView = defineAsyncComponent(props.mobile)
</script>
